export const stats = [
  { value: '+200', label: 'Clases listas' },
  { value: '+5000', label: 'Alumnas satisfechas' },
  { value: '3.800+', label: 'Horas ahorradas' },
  { value: '99%', label: 'Lo recomiendan' },
]

export const beforeItems = [
  'Horas planificando cada clase',
  'Clases repetitivas',
  'Sin profundidad filosófica',
  'No saber cuánto cobrar',
  'Alumnos que se van',
]

export const afterItems = [
  '5 minutos de repaso',
  'Clases con variedad',
  'Tema filosófico cada semana',
  'Precios claros y confianza',
  'Comunidad fiel',
]

export const transformationBadges = [
  { value: '+200', label: 'Clases' },
  { value: '5', label: 'Tomos' },
  { value: '100%', label: 'Descargable' },
]

export const painPoints = [
  'Llegás a clase sin saber exactamente qué dar',
  'Tardás horas planificando lo que podrías resolver en minutos',
  'No sabés cómo llevar la filosofía a la clase sin sonar forzada',
  'Cobrás menos de lo que merecés porque no sabés cómo posicionarte',
  'Tus alumnos siempre hacen lo mismo y tus clases no crecen',
]

export const kitContents = [
  {
    title: '5 Tomos Anuales',
    desc: '52 semanas de clases planificadas',
    icon: 'calendar' as const,
  },
  {
    title: 'Yoga Terapéutico',
    desc: '25 protocolos para dolencias reales',
    icon: 'leaf' as const,
  },
  {
    title: 'Filosofía y Temas',
    desc: '52 temas para elevar cada clase',
    icon: 'flower' as const,
  },
  {
    title: 'Biblioteca de Asanas',
    desc: '200+ posturas con cues verbales',
    icon: 'book' as const,
  },
  {
    title: 'El Negocio del Yoga',
    desc: 'Vivir del yoga en Argentina',
    icon: 'briefcase' as const,
  },
]

export const instantAccessItems = [
  { text: 'Las 52 Clases del Año', icon: 'calendar' as const },
  { text: 'La Guía de Ajustes', icon: 'hands' as const },
  { text: '60 Captions de Instagram', icon: 'phone' as const },
  { text: 'El Tracker del Profesor', icon: 'notebook' as const },
]

export const bonuses = [
  '30 Rituales de Apertura y Cierre',
  'Guía de Música para tus Clases',
  'Guía de Ajustes y Asistencias',
  '60 Captions de Instagram',
  'Tracker Anual del Profesor',
]

export const socialProofPurchases = [
  { name: 'Lucía O.', city: 'Villa Crespo, CABA', minutes: 4 },
  { name: 'Julieta B.', city: 'Córdoba Capital', minutes: 11 },
  { name: 'Rocío F.', city: 'Rosario, Santa Fe', minutes: 19 },
  { name: 'Agustina P.', city: 'San Isidro, Buenos Aires', minutes: 26 },
  { name: 'Malena T.', city: 'Neuquén', minutes: 33 },
]
